import { BoxProps, useBoxStyle, useTheme } from "arkh";
import Color from "color";
import React, { PropsWithChildren } from "react";
import { Pressable, StyleProp, ViewStyle } from "react-native";

export type ListItemProps = PropsWithChildren<
  {
    onPress?: () => void;
    isFirst?: boolean;
    isLast?: boolean;
    selected?: boolean;
    disabled?: boolean;
    dynamicHeight?: boolean;
    style?: StyleProp<ViewStyle>;
  } & BoxProps
>;

/**
 * @deprecated The method should not be used. Use <ListItem> instead.
 */
export function LegacyListItem({
  onPress,
  children,
  isFirst,
  isLast,
  selected,
  disabled,
  dynamicHeight,
  style,
  ...boxProps
}: ListItemProps) {
  const theme = useTheme();
  const color = boxProps.color ?? "surface";

  const _style = useBoxStyle({
    space: "medium",
    color,
    cornerRadiusTopLeft: isFirst ? "large" : "none",
    cornerRadiusTopRight: isFirst ? "large" : "none",
    cornerRadiusBottomLeft: isLast ? "large" : "none",
    cornerRadiusBottomRight: isLast ? "large" : "none",
    ...boxProps,
  });
  return (
    <Pressable
      disabled={disabled === true || !onPress}
      onPress={onPress}
      style={({ pressed }) => [
        _style,
        {
          flex: 1,
          flexDirection: "row",
          alignItems: "center",
          height: dynamicHeight ? undefined : LIST_ITEM_HEIGHT,
          minHeight: LIST_ITEM_HEIGHT,
          backgroundColor: pressed
            ? Color(theme[color]).alpha(0.7).toString()
            : selected
              ? Color(theme[color]).alpha(0.4).toString()
              : theme[color],
        },
        style,
      ]}
    >
      {children}
    </Pressable>
  );
}

export const LIST_ITEM_HEIGHT = 56;
